import { Entity } from '../entity';
import { LanguagePage, PageTitles, FeatureType } from '../lib/common';
import { Value } from './value.model';

export interface IInsightsResponse {
  totalPremises: number;
  telusCustomers: number;
  fibreSellablePremises: number;
  smarthubPremises: number;
  fibrePremises: number;
  hsicPremises: number;
  fibreHsicPremises: number;
  fibrePreSalesPremises: number;
  mobilityPremises: number;
  tvPremises: number;
  optikPremises: number;
  pikPremises: number;
  securityPremises: number;
  shsPremises: number;
  adtPremises: number;
  tosPremises: number;
  knockedPremises?: number;
  koodoPremises?: number;
}

export class InsightsResponse {
  private state: IInsightsResponse;

  constructor(insight: IInsightsResponse) {
    this.state = insight;
  }

  get totalPremises(): number {
    return this.state.totalPremises;
  }

  get telusCustomers(): number {
    return this.state.telusCustomers;
  }

  get fibreSellablePremises(): number {
    return this.state.fibreSellablePremises;
  }

  get smarthubPremises(): number {
    return this.state.smarthubPremises;
  }

  get fibrePremises(): number {
    return this.state.fibreSellablePremises;
  }

  get hsicPremises(): number {
    return this.state.hsicPremises;
  }

  get fibreHsicPremises(): number {
    return this.state.fibreHsicPremises;
  }

  get fibrePreSalesPremises(): number {
    return this.state.fibrePreSalesPremises;
  }

  get mobilityPremises(): number {
    return this.state.mobilityPremises;
  }

  get tvPremises(): number {
    return this.state.tvPremises;
  }

  get optikPremises(): number {
    return this.state.optikPremises;
  }

  get pikPremises(): number {
    return this.state.pikPremises;
  }

  get shsPremises(): number {
    return this.state.shsPremises;
  }

  get adtPremises(): number {
    return this.state.adtPremises;
  }

  get securityPremises(): number {
    return this.state.securityPremises;
  }

  get tosPremises(): number {
    return this.state.tosPremises;
  }

  get knockedPremises(): number {
    return this.state.knockedPremises;
  }

  get generateTerritoryInsight() {
    return [
      {
        title: 'insightPenetration',
        value:
          (
            (this.state.telusCustomers / this.state.totalPremises) *
            100
          ).toFixed(2) + '%',
      },
    ];
  }

  get generateTerritoryInsightSecondSection() {
    return [
      {
        title: 'insightPremises',
        value: this.state.totalPremises,
      },
      {
        title: 'insightTelusCustomers',
        value: this.state.telusCustomers,
      },
      {
        title: 'koodoCustomers',
        value: this.state.koodoPremises,
      },
      {
        title: 'insightFibreSellablePremises',
        value: this.state.fibreSellablePremises,
      },
      {
        title: 'insightFibrePreSalesPremises',
        value: this.state.fibrePreSalesPremises,
      },
      {
        title: 'insightSmarthubPremises',
        value: this.state.smarthubPremises,
      },
    ];
  }

  generateTerritoryInsightThirdSection(feature: string) {
    const insight = [
      {
        title: 'insightPremises',
        value: this.state.totalPremises,
      },
      {
        title: 'insightFibre',
        value:
          '' +
          ((this.state.fibrePremises / this.state.totalPremises) * 100).toFixed(
            2
          ) +
          '%/' +
          this.state.fibrePremises,
      },
      {
        title: 'insightHsic',
        value:
          '' +
          ((this.state.hsicPremises / this.state.totalPremises) * 100).toFixed(
            2
          ) +
          '%/' +
          this.state.hsicPremises,
      },
      {
        title: 'insightFibreHsic',
        value:
          (
            (this.state.fibreHsicPremises / this.state.totalPremises) *
            100
          ).toFixed(2) +
          '%/' +
          this.state.fibreHsicPremises,
      },
      {
        title: 'insightSmarthub',
        value:
          (
            (this.state.smarthubPremises / this.state.totalPremises) *
            100
          ).toFixed(2) +
          '%/' +
          this.state.smarthubPremises,
      },
      {
        title: 'koodoPenetrations',
        value:
          ((this.state.koodoPremises / this.state.totalPremises) * 100).toFixed(
            2
          ) +
          '%/' +
          this.state.koodoPremises,
      },
      {
        title: 'insightMobility',
        value:
          (
            (this.state.mobilityPremises / this.state.totalPremises) *
            100
          ).toFixed(2) +
          '%/' +
          this.state.mobilityPremises,
      },
      {
        title: 'insightTv',
        value:
          ((this.state.tvPremises / this.state.totalPremises) * 100).toFixed(
            2
          ) +
          '%/' +
          this.state.tvPremises,
      },
      {
        title: 'insightOptik',
        value:
          ((this.state.optikPremises / this.state.totalPremises) * 100).toFixed(
            2
          ) +
          '%/' +
          this.state.optikPremises,
      },
      {
        title: 'insightPik',
        value:
          ((this.state.pikPremises / this.state.totalPremises) * 100).toFixed(
            2
          ) +
          '%/' +
          this.state.pikPremises,
      },
      {
        title: 'insightSecurity',
        value:
          (
            (this.state.securityPremises / this.state.totalPremises) *
            100
          ).toFixed(2) +
          '%/' +
          this.state.securityPremises,
      },
      {
        title: 'insightShs',
        value:
          ((this.state.shsPremises / this.state.totalPremises) * 100).toFixed(
            2
          ) +
          '%/' +
          this.state.shsPremises,
      },
      {
        title: 'insightAdt',
        value:
          ((this.state.adtPremises / this.state.totalPremises) * 100).toFixed(
            2
          ) +
          '%/' +
          this.state.adtPremises,
      },
      {
        title: 'insightTos',
        value:
          ((this.state.tosPremises / this.state.totalPremises) * 100).toFixed(
            2
          ) +
          '%/' +
          this.state.tosPremises,
      },
    ];
    if (feature !== FeatureType.grid) {
      if (this.knockedPremises !== 0) {
        insight.push({
          title: 'insightKnock',
          value:
            (
              (this.state.knockedPremises / this.state.totalPremises) *
              100
            ).toFixed(2) + '%',
        });
      }
    }
    return insight;
  }
}
